import { default as formErrors } from './formErrors.json'
import { default as formFields } from './formFields.json'
import { default as formMessages } from './formMessages.json'
import { default as buttons } from './buttons.json'
import { default as claimStates } from './claimStates.json'
import { default as errors } from './errors.json'
import { default as airbnbPromo } from './airbnbPromo.json'
import { default as faqCategories } from './faqCategories.json'
import { default as general } from './general.json'
import { default as formSidebar } from './formSidebar.json'
import { default as titles } from './titles.json'

export default {
  formErrors,
  formFields,
  formMessages,
  buttons,
  claimStates,
  errors,
  airbnbPromo,
  faqCategories,
  general,
  formSidebar,
  titles,
}
